import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Y si lo hace distinto?',
  answer: 'Bien. Distinto no es peor. La meta es que no vuelva a tu cabeza.'
}, {
  question: '¿Y si me pregunta igual?',
  answer: 'El kit te da respuestas cortas para volverlo a la tarjeta, sin discutir.'
}, {
  question: '¿Y si tengo cero tiempo?',
  answer: 'El plan está diseñado para 5–15 minutos por día.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-6 py-16 bg-cream" data-id="element-1">
      <div className="max-w-reading mx-auto" data-id="element-2">
        <h2 className="text-2xl font-serif text-brown mb-8 text-center" data-id="element-3">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-4">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg border border-stone-200 overflow-hidden" data-id="element-5">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left text-brown font-medium hover:bg-stone-50 transition-colors" data-id="element-6">
                <span data-id="element-7">{faq.question}</span>
                <ChevronDown className={`w-5 h-5 text-ochre transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-8" />
              </button>

              <AnimatePresence data-id="element-9">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-10">
                    <div className="p-5 pt-0 text-brown/80 leading-relaxed border-t border-stone-100" data-id="element-11">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}